import React from 'react';
import { ReactionOutput, EMOJIS } from './types';

interface ReactionListProps {
  reactions: ReactionOutput[];
  currentUserId?: string;
}

export const ReactionList: React.FC<ReactionListProps> = ({
  reactions,
  currentUserId,
}) => {
  const getEmojiDisplay = (emojiCode: string): string => {
    const emoji = EMOJIS.find(e => e.code === emojiCode);
    return emoji?.emoji || '😀';
  };

  if (reactions.length === 0) {
    return (
      <div className="text-center py-8 text-muted dark:text-disabled">
        Be the first to react!
      </div>
    );
  }

  // Sort by newest first
  const sortedReactions = [...reactions].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );

  return (
    <div className="max-h-[300px] overflow-y-auto">
      <ul className="divide-y divide-edge dark:divide-gray-700">
        {sortedReactions.map((reaction) => (
          <li
            key={reaction.playerId}
            className={`
              px-4 py-3 flex items-center gap-3
              ${reaction.playerId === currentUserId ? 'bg-primary-50 dark:bg-primary-900/20' : ''}
            `}
          >
            <span className="text-2xl">{getEmojiDisplay(reaction.emoji)}</span>
            <span className="text-sm text-body dark:text-faint">
              <span className="font-medium">{reaction.playerName}</span>
              {reaction.playerId === currentUserId && (
                <span className="ml-2 text-xs text-primary-600 dark:text-primary-400">(You)</span>
              )}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
